import SelectField from '../../../../common/formComponents/SelectField/SelectField';
import TextField from '../../../../common/formComponents/TextField/TextField';
import { getInputOptions } from '../../utils/getInputOptions';
import moment from 'moment';

export const getBaseNameFields = ({ tenantData, isRequired = true }) => [
  {
    label: 'Фамилия',
    name: 'surName',
    options: getInputOptions({
      ...(isRequired && { requiredErrMsg: 'Укажите фамилию' }),
      initialValue: tenantData?.surName,
    }),
    span: 8,
    element: TextField,
    inputProps: {
      placeholder: 'Иванов',
    },
  },
  {
    label: 'Имя',
    name: 'firstName',
    options: getInputOptions({
      initialValue: tenantData?.firstName,
    }),
    span: 8,
    element: TextField,
    inputProps: {
      placeholder: 'Иван',
    },
  },
  {
    label: 'Отчество',
    name: 'patrName',
    options: getInputOptions({
      initialValue: tenantData?.patrName,
    }),
    span: 8,
    element: TextField,
    inputProps: {
      placeholder: 'Иванович',
    },
  },
];

export const getFioField = ({ tenantData }) => ({
  label: 'ФИО жильца',
  name: 'fio',
  options: getInputOptions({
    initialValue: tenantData?.fio,
  }),
  span: 24,
  element: TextField,
  inputProps: {
    disabled: true,
  },
});

export const getVerifiedField = ({ tenantData }) => [
  {
    label: 'Признак подтверждения паспортных данных',
    name: 'isVerified',
    options: getInputOptions({
      initialValue:
        tenantData?.isVerified === true
          ? 'true'
          : tenantData?.isVerified === false
          ? 'false'
          : 'null',
    }),
    selectOptions: [
      { id: 1, name: 'Подтвержден', value: 'true' },
      { id: 2, name: 'Не подтвержден', value: 'false' },
      { id: 3, name: 'Требуется проверка', value: 'null' },
    ],
    valueKey: 'value',
    contentKey: 'name',
    span: 24,
    element: SelectField,
  },
  {
    label: 'Дата проверки паспортных данных',
    name: 'verificationDate',
    options: getInputOptions({
      initialValue: !!tenantData?.verificationDate
        ? moment(tenantData.verificationDate).format('DD.MM.YYYY')
        : '',
    }),
    span: 24,
    element: TextField,
    inputProps: {
      disabled: true,
    },
  },
];
